// Footer.jsx
import React from 'react';
import styled from 'styled-components';
import Logo1 from "../Images/Ambassador.png";
import Partner1 from "../Images/fi1.jpeg";
import Partner2 from "../Images/fi2.jpeg";
import Partner3 from "../Images/fi3.jpeg";
import Partner4 from "../Images/fi4.jpeg";
import { useNavigate, useLocation } from "react-router-dom";

const FooterContainer = styled.footer`
  background-color: rgba(0, 0, 0, 0.9);
  color: #fff;
  padding: 50px 20px 20px 20px;
  font-family: Arial, sans-serif;
`;

const FooterTop = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  justify-content: space-between;
`;

const FooterSection = styled.div`
  flex: 1;
  min-width: 250px;
`;

const Logo = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-bottom: 10px;
`;

const FooterHeading = styled.h4`
  margin-bottom: 15px;
  text-decoration: underline;
`;

const FooterText = styled.p`
  font-size: 0.8rem;
  line-height: 1.5;
`;

const FooterLink = styled.p`
  cursor: pointer;
  margin-bottom: 8px;

  &:hover {
    text-decoration: underline;
  }
`;

const PartnersSection = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  margin-top: 20px;
  flex-wrap: wrap;
`;

const PartnerImage = styled.img`
  width: 120px;
  object-fit: contain;
  border-radius: 10px;
`;

const CopyRight = styled.div`
  text-align: center;
  margin-top: 40px;
  font-size: 0.75rem;
  color: rgba(255,255,255,0.7);

  span {
    color: rgba(0,100,255,0.7);
  }
`;

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleAbout = (about) => {
    if (about) {
      const element = document.getElementById('about');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <FooterContainer>
      <FooterTop>

        {/* About Section */}
        <FooterSection>
          <Logo src={Logo1} alt="logo" />
          <h4>ENGR. CHINEDU JOSEPH NDU</h4>
          <FooterText>
            Beyond my technical skills, I am known for my collaborative spirit and leadership qualities. 
            I excel in coordinating multidisciplinary teams and navigating complex challenges, always striving 
            for excellence in every project. My ability to communicate complex ideas clearly and my keen eyes 
            for details have earned me a reputation as a reliable and innovative engineer.
          </FooterText>

        </FooterSection>

        {/* Quick Links */}
        <FooterSection>
          <FooterHeading>Quick Links</FooterHeading>
          <FooterLink onClick={() => navigate("/")}>Home</FooterLink>
          {location.pathname === "/" && 
            <FooterLink onClick={() => handleAbout("about")}>About</FooterLink>
          }
          <FooterLink onClick={() => navigate("/contactus")}>Contact Us</FooterLink>
        </FooterSection>

        {/* Contact */}
        <FooterSection>
          <FooterHeading>Contact</FooterHeading>
          <FooterText>Email: neduforad@yahoo.com</FooterText>
          <FooterText>Phone: +234 803 090 6974</FooterText>
        </FooterSection>

        {/* EXPERIENCE Section — replaces Social */}
        <FooterSection>
          <FooterHeading>EXPERIENCES</FooterHeading>
          <PartnersSection>
            <PartnerImage src={Partner1} alt="experience1" />
            <PartnerImage src={Partner2} alt="experience2" />
            <PartnerImage src={Partner3} alt="experience3" />
            <PartnerImage src={Partner4} alt="experience4" />
          </PartnersSection>
        </FooterSection>

      </FooterTop>

      <CopyRight>
        <p>© Copyright {new Date().getFullYear()} ENGR. CHINEDU JOSEPH NDU. All Rights Reserved</p>
        <p><span>POWERED BY</span> ECHOBYTE CONCEPT</p>
      </CopyRight>
    </FooterContainer>
  );
};

export default Footer;
